import { RailsSessionUser } from '@sls-react/typings/services/rails/session';
import { IAMUser } from '@sls-react/typings/services/iam/auth';

export default function identifySentryUser(user: IAMUser | RailsSessionUser) {
  return {
    email: user.email,
    id: user.external_id,
    username: user.username,
  };
}
